import { MessageCircle, ArrowRight } from 'lucide-react';
import { useState, useEffect } from 'react';
import { TID } from '@/constants/testIds';
import { BRAND, whatsappUrl } from '@/constants/content';

export default function Floating() {
    const go = () => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    const [waHref, setWaHref] = useState(`https://wa.me/${BRAND.whatsapp}`);
    useEffect(() => {
        setWaHref(whatsappUrl());
    }, []);
    return (
        <>
            {/* Mobile sticky CTA bar */}
            <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-hairline px-4 py-3 flex items-center gap-3 shadow-[0_-8px_30px_rgba(15,26,44,0.06)]">
                <button
                    onClick={go}
                    data-testid={TID.mobileStickyCta}
                    className="flex-1 inline-flex items-center justify-center gap-2 bg-navy text-white px-4 py-3 text-[12px] font-semibold tracking-widest2 uppercase"
                >
                    Book Consultation
                    <ArrowRight className="w-3.5 h-3.5" />
                </button>
                <a
                    href={`tel:${BRAND.phones[0].replace(/\s/g, '')}`}
                    className="inline-flex items-center justify-center gap-2 border border-navy text-navy px-4 py-3 text-[12px] font-semibold tracking-widest2 uppercase"
                >
                    Call
                </a>
            </div>

            {/* Floating WhatsApp button (offset above mobile bar on small screens) */}
            <a
                href={waHref}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={TID.whatsappFloat}
                aria-label="Chat on WhatsApp"
                className="fixed right-5 z-40 bg-[#25D366] hover:bg-[#1eb558] text-white p-4 rounded-full shadow-[0_12px_30px_rgba(37,211,102,0.45)] hover:scale-110 transition-all duration-300 bottom-24 lg:bottom-6"
            >
                <MessageCircle className="w-5 h-5" />
            </a>
        </>
    );
}
